import React from 'react';
import styled from 'styled-components';
import { formatCurrency } from 'js/services/Format';

export default styled(props => <span {...props}>{formatCurrency().replace('NaN','')}</span>)`
  position: absolute;
  left: 0;
  width: 2rem;
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 2.5rem;
`;
